import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import { zip } from 'rxjs';

export function removeByIdsFn(api: AtlazApiV2Service, key: string) {
  return (ids: (string | number)[]) => {
    const removeRequests$ = ids.map(id => api.deleteRequest([key, id]));
    return zip(...removeRequests$);
  };
}
